import React, { Component } from 'react';
import Header from './header/header'

class OurMethodology extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    render() {
        return (
            <div>
            <Header />
                <section class="ovrfl">
                    <div class="container">

                        <div class="row breadcrumb text-center trght">
                            <div class="col-md-12">
                                <span>Home</span> <i class="fa fa-angle-right"></i>
                                <span>Pages</span> <i class="fa fa-angle-right"></i>
                                <span>Methodology </span>
                            </div>
                        </div>

                        <div class="row pad_0">
                            <div class="col-md-12 consult_bg">
                                <div class="col-md-4 col-md-push-8 pador">
                                    <ul class="unli top-to-bottom">
                                        <li><button class="btn btn-consult b1 consult_btn"><i class="fa fa-circle"></i> define the market</button></li>
                                        <li><button class="btn btn-consult b2 consult_btn"><i class="fa fa-circle"></i> Market mapping and segmentation</button></li>
                                        <li><button class="btn btn-consult b3 consult_btn"><i class="fa fa-circle"></i> determine information need</button></li>
                                        <li><button class="btn btn-consult b4 consult_btn"><i class="fa fa-circle"></i> primary search</button></li>
                                        <li><button class="btn btn-consult b5 consult_btn"><i class="fa fa-circle"></i> secondary search</button></li>
                                        <li><button class="btn btn-consult b6 consult_btn"><i class="fa fa-circle"></i> expert validation</button></li>
                                        <li><button class="btn btn-consult b7 consult_btn"><i class="fa fa-circle"></i> data presentation</button></li>
                                    </ul>

                                </div>
                                <div class="col-md-8 col-md-pull-4 wt">
                                    <div class="txt1"><h3>01</h3></div>
                                    <div class="txt2"><h3 class="consu_1">Secondary Research</h3>
                                        <p class="p_family">Secondary ResearchInformation is collected from a number of publicly available as well as paid databases. Public sources involve publications by different associations and governments, annual reports and statements of companies, white papers and research publications by recognized industry experts and renowned academia etc. Paid data sources include third party authentic industry databases.
                                        </p>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="txt1"><h3>02</h3></div>
                                    <div class="txt2"><h3 class="consu_1">PRIMARY Research</h3>
                                        <p class="p_family">Once data collection is done through secondary research, primary interviews are conducted with different stakeholders across the value chain like manufacturers, distributors, ingredient/input suppliers, end customers and other key opinion leaders of the industry. Primary research is used both to validate the data points obtained from secondary research and to fill in the data gaps after secondary research.
                                        </p>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="txt1"><h3>03</h3></div>
                                    <div class="txt2"><h3 class="consu_1">MARKET ENGINEERING</h3>
                                        <p class="p_family">The market engineering phase involves analyzing the data collected, market breakdown and forecasting. Macroeconomic indicators and bottom-up and top-down approaches are used to arrive at a complete set of data points that give way to valuable qualitative and quantitative insights. Each data point is verified by the process of data triangulation to validate the numbers and arrive at close estimates.
                                        </p>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="txt1"><h3>04</h3></div>
                                    <div class="txt2"><h3 class="consu_1">EXPERT VALIDATION</h3>
                                        <p class="p_family">The market engineered data is verified and validated by a number of experts, both in-house and external.

                                        </p>
                                    </div>
                                    <div class="clearfix"></div>

                                    <div class="txt1"><h3>05</h3></div>
                                    <div class="txt2"><h3 class="consu_1">REPORT WRITING/ PRESENTATION</h3>
                                        <p class="p_family">After the data is curated by the mentioned highly sophisticated process, the analysts begin to write the report. Garnering insights from data and forecasts, insights are drawn to visualize the entire ecosystem in a single report.
                                        </p>
                                    </div>
                                    <div class="clearfix"></div>




                                </div>

                            </div>
                        </div>

                    </div>
                </section>
            </div>
        );
    }


}


export default OurMethodology;


// WEBPACK FOOTER //
// ./src/consulting/OurMethodology/OurMethodology.js